import { cn as e } from "../../lib/utils.es.js";
import "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-avatar";
// libs/ui-lib/src/components/ui/avatar.tsx
function r({ className: r, ...i }) {
	return /* @__PURE__ */ t(n.Root, {
		"data-slot": "avatar",
		className: e("relative flex size-8 shrink-0 overflow-hidden rounded-full", r),
		...i
	});
}
function i({ className: r, ...i }) {
	return /* @__PURE__ */ t(n.Image, {
		"data-slot": "avatar-image",
		className: e("aspect-square size-full", r),
		...i
	});
}
function a({ className: r, ...i }) {
	return /* @__PURE__ */ t(n.Fallback, {
		"data-slot": "avatar-fallback",
		className: e("bg-muted flex size-full items-center justify-center rounded-full", r),
		...i
	});
}
export { r as Avatar, a as AvatarFallback, i as AvatarImage };
